import React, { JSX } from 'react';

// html entity unicode for &nbsp;
export const nbsp = '\u00A0';

// React component
export const Nbsp = (): JSX.Element => <>{nbsp}</>;
